export default {"src":"/_next/static/image/public/images/ic_green_radio_checked.bc159ef0f28fd29a8aeb336afd49487d.svg","height":24,"width":24};